// services/atualizarCotaUsuario.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
// --------------------- Import Interface ---------------------
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const atualizarCotaUsuario = async (
  cotaUsuarioId: number | undefined | null,
  valuesMaisInfo: CotaUsuario
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
    try {
      const response = await axios.put(URL, valuesMaisInfo, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
